<div class="account-container" role="presentation">
<button [attr.aria-label]="t('header.account_button.button_aria_label')" (click)="handleClick()"
  class="button-undecorated account-button"
  [ngClass]="{'label-visible': (layoutService.state().viewport !== 'mobile' && !isLoggedIn())}" *transloco="let t;">
  @if(layoutService.state().viewport !== 'mobile' && !isLoggedIn()){
  <span class="label">{{t('header.account_button.sign_in')}}</span>
  }
  <div class="dropdown-container">
    <div class="expandable-view-container" [ngClass]="{ 'expanded': isLoggedIn() }" id="account_dropdown_header">
      <div class="user-icon-container" [ngClass]="{'logged-in': isLoggedIn()}">
        <cwo-icon [name]="iconName.user" class="user-icon" />
      </div>
      @if(isLoggedIn() && layoutService.state().viewport !== 'mobile'){
      <cwo-icon [name]="iconName.arrow" class="arrow-icon" [@rotate]="!showDropdown()" />
      }
    </div>
  </div>
</button>

@if (showDropdown()) {
<div #dropdownMenu class="dropdown-menu" [class.bottom]="showDropdown()" [ngClass]="{ hidden: !showDropdown() }"
  id="acount_dropdown_menu" [attr.aria-labelledby]="'account_dropdown_header'" *transloco="let t;">
  <span class="name">{{ fullName().toLocaleLowerCase() }}</span>
  <div class="text-button-group">
    <cwo-text-button class="text-button" [iconName]="iconName.user" [ariaLabel]="t('header.account_button.profile')" (buttonClicked)="closeDropdown()"
      [gap]="'1rem'" [padding]="'0.5rem'" [routerLink]="storeIdService.getRoutePathSegments(['account', 'profile'])">
      <span class="text-button-content"
        [ngClass]="{'focused': isProfilePage}">{{t('header.account_button.profile')}}</span>
    </cwo-text-button>
    <cwo-text-button class="text-button" [iconName]="iconName.notification" (buttonClicked)="closeDropdown()"
      [ariaLabel]="t('header.account_button.notification_options')" [gap]="'1rem'" [padding]="'0.5rem'"
      [routerLink]="storeIdService.getRoutePathSegments(['account', 'notification-options'])">
      <span class="text-button-content"
        [ngClass]="{'focused': isNotificationPage}">{{t('header.account_button.notification_options')}}</span>
    </cwo-text-button>
    <cwo-text-button class="text-button" [iconName]="iconName.addressBook" (buttonClicked)="closeDropdown()"
      [ariaLabel]="t('header.account_button.address_book')" [gap]="'1rem'" [padding]="'0.5rem'"
      [routerLink]="storeIdService.getRoutePathSegments(['account', 'address-book'])">
      <span class="text-button-content"
        [ngClass]="{'focused': isAddressPage}">{{t('header.account_button.address_book')}}</span>
    </cwo-text-button>
    @if(storeConfig?.hasCreditCard || storeConfig?.hasGiftCard){
    <cwo-text-button class="text-button" [iconName]="iconName.wallet" [ariaLabel]="t('header.account_button.wallet')" (buttonClicked)="closeDropdown()"
      [gap]="'1rem'" [padding]="'0.5rem'" [routerLink]="storeIdService.getRoutePathSegments(['account', 'wallet'])">
      <span class="text-button-content"
        [ngClass]="{'focused': isWalletPage}">{{t('header.account_button.wallet')}}</span>
    </cwo-text-button>
    }
    <cwo-text-button class="text-button" [iconName]="iconName.grocery" (buttonClicked)="closeDropdown()"
      [ariaLabel]="t('header.account_button.order_history')" [gap]="'1rem'" [padding]="'0.5rem'"
      [routerLink]="storeIdService.getRoutePathSegments(['account', 'my-orders'])">
      <span class="text-button-content"
        [ngClass]="{'focused': isMyOrdersPage}">{{t('header.account_button.order_history')}}</span>
    </cwo-text-button>
     <cwo-text-button class="text-button" [iconName]="iconName.gift" (buttonClicked)="closeDropdown()"
      [ariaLabel]="t('header.account_button.invite_friends')" [gap]="'1rem'" [padding]="'0.5rem'"
      [routerLink]="storeIdService.getRoutePathSegments(['account', 'invite-friends'])">
      <span class="text-button-content"
        [ngClass]="{'focused': isInviteFriendsPage}">{{t('header.account_button.invite_friends')}}</span>
    </cwo-text-button>
  </div>
  <div class="divider-container">
    <div class="divider"></div>
  </div>
  <cwo-text-button class="text-button" [iconName]="iconName.logOut" [ariaLabel]="t('header.account_button.sign_out')"
    [gap]="'1rem'" [padding]="'0.5rem'" (click)="onLogout()">
    <span class="text-button-content">{{t('header.account_button.sign_out')}}</span>
  </cwo-text-button>
</div>
}

</div>